$(function() {
    $(document).on("click", ".google-maps-formatter", function(e) {
        e.preventDefault();
        let title = $(this).attr('data-title');
        let latitude = $(this).attr('data-latitude');
        let longitude = $(this).attr('data-longitude');
        let radius = $(this).attr('data-radius');
        let marker = $(this).attr('data-marker');
        let information = $(this).attr('data-information');
        let zoom = $(this).attr('data-zoom');
        let type = $(this).attr('data-type');
        let googleMapsUrl = new URL(url+"/google-maps/");
        if (typeof latitude !== "undefined") {
            googleMapsUrl.searchParams.append("latitude", latitude);
        }
        if (typeof longitude !== "undefined") {
            googleMapsUrl.searchParams.append("longitude", longitude);
        }
        if (typeof radius !== "undefined") {
            googleMapsUrl.searchParams.append("radius", radius);
        }
        if (typeof marker !== "undefined") {
            googleMapsUrl.searchParams.append("marker", marker);
        }
        if (typeof information !== "undefined") {
            googleMapsUrl.searchParams.append("information", information);
        }
        if (typeof zoom !== "undefined") {
            googleMapsUrl.searchParams.append("zoom", zoom);
        }
        if (typeof type !== "undefined") {
            googleMapsUrl.searchParams.append("type", type);
        }
        /*
        BootstrapDialog.show({
            size: BootstrapDialog.SIZE_WIDE,
            type: BootstrapDialog.TYPE_PRIMARY,
            title: title,
            message:  $('<div><iframe src="'+googleMapsUrl.href+'" width="100%" height="400" style="border: none"></iframe></div>')
        });
        */
        bootbox.dialog({
            title: title,
            message: '<div class="p-0"><iframe src="'+googleMapsUrl.href+'" width="100%" height="400" style="border: none"></iframe></div>',
            size: 'large',
            buttons: {
                ok: {
                    label: __('Close'),
                    className: 'btn-primary'
                }
            }
        });
    });
});
